import { ScoreType } from '../../models';

export const evaluatorConstants = {
  OPEN_INQUIRY: 'EVALUATOR_OPEN_INQUIRY',
  CLEAR_INQUIRY: 'EVALUATOR_CLEAR_INQUIRY',
  OPEN_EDIT: 'EVALUATOR_OPEN_EDIT',
  CLEAR_EDIT: 'EVALUATOR_CLEAR_EDIT',
};

export const NCAAMEvaluatorConfig = {
  dPanel: [{ name: 'Difficulty', type: ScoreType.D }],
  ePanel: [
    { name: 'E1 Judge', type: ScoreType.E1 },
    { name: 'E2 Judge', type: ScoreType.E2 },
  ],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
  maxTeamLineup: 5,
  defaultLineupSize: 4,
  aaIndex: 6,
};

export const NCAAM4EvaluatorConfig = {
  dPanel: [{ name: 'Difficulty', type: ScoreType.D }],
  ePanel: [
    { name: 'E1 Judge', type: ScoreType.E1 },
    { name: 'E2 Judge', type: ScoreType.E2 },
    { name: 'E3 Judge', type: ScoreType.E3 },
    { name: 'E4 Judge', type: ScoreType.E4 },
  ],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
  maxTeamLineup: 5,
  defaultLineupSize: 4,
  aaIndex: 6,
};

export const NCAAWEvaluatorConfig = {
  dPanel: [{ name: 'Start Value', type: ScoreType.SV }],
  ePanel: [],
  jPanel: [
    { name: 'J1 Judge', type: ScoreType.J1 },
    { name: 'J2 Judge', type: ScoreType.J2 },
  ],
  nDeduct: true,
  stickBonus: false,
  startValue: true,
  startValueOptional: true,
  minimumDeduction: 0.05,
  disableInputChecking: false,
  maxTeamLineup: 6,
  defaultLineupSize: 6,
  exhibitionIndex: 7,
};

export const NCAAW2EvaluatorConfig = {
  svPanel: [
    { name: 'SV1', type: ScoreType.SV1 },
    { name: 'SV2', type: ScoreType.SV2 },
  ],
  dPanel: [],
  ePanel: [],
  jPanel: [
    { name: 'J1 Judge', type: ScoreType.J1 },
    { name: 'J2 Judge', type: ScoreType.J2 },
  ],
  roles: {
    [ScoreType.J1]: {
      [ScoreType.J1]: true,
      [ScoreType.SV1]: true,
      [ScoreType.ND]: true,
      finalize: true,
      inquiry: true,
    },
    [ScoreType.J2]: {
      [ScoreType.J2]: true,
      [ScoreType.SV2]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
  },
  nDeduct: true,
  stickBonus: false,
  startValue: true,
  startValueOptional: true,
  minimumDeduction: 0.05,
  disableInputChecking: false,
  maxTeamLineup: 6,
  defaultLineupSize: 6,
  exhibitionIndex: 7,
};

export const NCAAW2SVEvaluatorConfig = {
  ...NCAAW2EvaluatorConfig,
  startValueOptional: false,
};

export const NCAAW4EvaluatorConfig = {
  svPanel: [
    { name: 'SV1', type: ScoreType.SV1 },
    { name: 'SV2', type: ScoreType.SV2 },
    { name: 'SV3', type: ScoreType.SV3 },
    { name: 'SV4', type: ScoreType.SV4 },
  ],
  dPanel: [],
  ePanel: [],
  jPanel: [
    { name: 'J1 Judge', type: ScoreType.J1 },
    { name: 'J2 Judge', type: ScoreType.J2 },
    { name: 'J3 Judge', type: ScoreType.J3 },
    { name: 'J4 Judge', type: ScoreType.J4 },
  ],
  roles: {
    [ScoreType.J1]: {
      [ScoreType.J1]: true,
      [ScoreType.SV1]: true,
      [ScoreType.ND]: true,
      finalize: true,
      inquiry: true,
    },
    [ScoreType.J2]: {
      [ScoreType.J2]: true,
      [ScoreType.SV2]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J3]: {
      [ScoreType.J3]: true,
      [ScoreType.SV3]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J4]: {
      [ScoreType.J4]: true,
      [ScoreType.SV4]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
  },
  nDeduct: true,
  stickBonus: false,
  startValue: true,
  minimumDeduction: 0.05,
  disableInputChecking: false,
  startValueOptional: false,
  maxTeamLineup: 6,
  defaultLineupSize: 6,
  exhibitionIndex: 7,
};

export const NCAAW6EvaluatorConfig = {
  svPanel: [
    { name: 'SV1', type: ScoreType.SV1 },
    { name: 'SV2', type: ScoreType.SV2 },
    { name: 'SV3', type: ScoreType.SV3 },
    { name: 'SV4', type: ScoreType.SV4 },
    { name: 'SV5', type: ScoreType.SV5 },
    { name: 'SV6', type: ScoreType.SV6 },
  ],
  dPanel: [],
  ePanel: [],
  jPanel: [
    { name: 'J1 Judge', type: ScoreType.J1 },
    { name: 'J2 Judge', type: ScoreType.J2 },
    { name: 'J3 Judge', type: ScoreType.J3 },
    { name: 'J4 Judge', type: ScoreType.J4 },
    { name: 'J5 Judge', type: ScoreType.J5 },
    { name: 'J6 Judge', type: ScoreType.J6 },
  ],
  roles: {
    [ScoreType.J1]: {
      [ScoreType.J1]: true,
      [ScoreType.SV1]: true,
      [ScoreType.ND]: true,
      finalize: true,
      inquiry: true,
    },
    [ScoreType.J2]: {
      [ScoreType.J2]: true,
      [ScoreType.SV2]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J3]: {
      [ScoreType.J3]: true,
      [ScoreType.SV3]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J4]: {
      [ScoreType.J4]: true,
      [ScoreType.SV4]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J5]: {
      [ScoreType.J5]: true,
      [ScoreType.SV5]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J6]: {
      [ScoreType.J6]: true,
      [ScoreType.SV6]: true,
      [ScoreType.ND]: false,
      finalize: false,
      inquiry: false,
    },
  },
  nDeduct: true,
  stickBonus: false,
  startValue: true,
  minimumDeduction: 0.05,
  disableInputChecking: false,
  startValueOptional: false,
  maxTeamLineup: 6,
  defaultLineupSize: 6,
  exhibitionIndex: 7,
};

export const fiveEvaluatorConfig = {
  dPanel: [{ name: 'D Judge', type: ScoreType.D }],
  ePanel: [
    { name: 'E1 Judge', type: ScoreType.E1 },
    { name: 'E2 Judge', type: ScoreType.E2 },
    { name: 'E3 Judge', type: ScoreType.E3 },
  ],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
};

export const fig6EvaluatorConfig = {
  dPanel: [
    { name: 'D1 Judge', type: ScoreType.D1 },
    { name: 'D2 Judge', type: ScoreType.D2 },
  ],
  ePanel: [
    { name: 'E1 Judge', type: ScoreType.E1 },
    { name: 'E2 Judge', type: ScoreType.E2 },
    { name: 'E3 Judge', type: ScoreType.E3 },
    { name: 'E4 Judge', type: ScoreType.E4 },
    { name: 'E5 Judge', type: ScoreType.E5 },
    { name: 'E6 Judge', type: ScoreType.E6 },
  ],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
};

export const fig5EvaluatorConfig = {
  dPanel: [
    { name: 'D1 Judge', type: ScoreType.D1 },
    { name: 'D2 Judge', type: ScoreType.D2 },
  ],
  ePanel: [
    { name: 'E1 Judge', type: ScoreType.E1 },
    { name: 'E2 Judge', type: ScoreType.E2 },
    { name: 'E3 Judge', type: ScoreType.E3 },
    { name: 'E4 Judge', type: ScoreType.E4 },
    { name: 'E5 Judge', type: ScoreType.E5 },
  ],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
};

export const fig4EvaluatorConfig = {
  dPanel: [
    { name: 'D1 Judge', type: ScoreType.D1 },
    { name: 'D2 Judge', type: ScoreType.D2 },
  ],
  ePanel: [
    { name: 'E1 Judge', type: ScoreType.E1 },
    { name: 'E2 Judge', type: ScoreType.E2 },
    { name: 'E3 Judge', type: ScoreType.E3 },
    { name: 'E4 Judge', type: ScoreType.E4 },
  ],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
};

export const singleEvaluatorConfig = {
  dPanel: [{ name: 'D Judge', type: ScoreType.D }],
  ePanel: [{ name: 'E Judge', type: ScoreType.E }],
  nDeduct: true,
  stickBonus: true,
  minimumDeduction: 0.1,
};

export const fanEvaluatorConfig = {
  dPanel: [],
  ePanel: [],
  fPanel: [{ name: 'FAN', type: ScoreType.F }],
  roles: {
    [ScoreType.F]: {
      [ScoreType.F]: true,
      finalize: true,
      inquiry: false,
    },
  },
  nDeduct: false,
  stickBonus: false,
  minimumDeduction: 1,
};

export const j4EvaluatorConfig = {
  dPanel: [],
  ePanel: [],
  jPanel: [
    { name: 'J1 Judge', type: ScoreType.J1 },
    { name: 'J2 Judge', type: ScoreType.J2 },
    { name: 'J3 Judge', type: ScoreType.J3 },
    { name: 'J4 Judge', type: ScoreType.J4 },
  ],
  nDeduct: false,
  stickBonus: false,
  minimumDeduction: 1,
};

export const openEvaluatorConfig = {
  dPanel: [],
  ePanel: [],
  jPanel: [{ name: 'Open Score', type: ScoreType.OPEN }],
  nDeduct: false,
  stickBonus: false,
  minimumDeduction: 0.001,
  disableInputChecking: true,
};

// NCAAW U variants - with per-judge UTL tracking
export const NCAAWUEvaluatorConfig = {
  ...NCAAWEvaluatorConfig,
  utl: true,
  utlPanel: [
    { name: 'UTL1', type: ScoreType.UTL1 },
    { name: 'UTL2', type: ScoreType.UTL2 },
  ],
};

export const NCAAW2UEvaluatorConfig = {
  ...NCAAW2EvaluatorConfig,
  utl: true,
  utlPanel: [
    { name: 'UTL1', type: ScoreType.UTL1 },
    { name: 'UTL2', type: ScoreType.UTL2 },
  ],
  roles: {
    [ScoreType.J1]: {
      [ScoreType.J1]: true,
      [ScoreType.SV1]: true,
      [ScoreType.ND]: true,
      [ScoreType.UTL1]: true,
      finalize: true,
      inquiry: true,
    },
    [ScoreType.J2]: {
      [ScoreType.J2]: true,
      [ScoreType.SV2]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL2]: true,
      finalize: false,
      inquiry: false,
    },
  },
};

export const NCAAW2SVUEvaluatorConfig = {
  ...NCAAW2UEvaluatorConfig,
  startValueOptional: false,
};

export const NCAAW4UEvaluatorConfig = {
  ...NCAAW4EvaluatorConfig,
  utl: true,
  utlPanel: [
    { name: 'UTL1', type: ScoreType.UTL1 },
    { name: 'UTL2', type: ScoreType.UTL2 },
    { name: 'UTL3', type: ScoreType.UTL3 },
    { name: 'UTL4', type: ScoreType.UTL4 },
  ],
  roles: {
    [ScoreType.J1]: {
      [ScoreType.J1]: true,
      [ScoreType.SV1]: true,
      [ScoreType.ND]: true,
      [ScoreType.UTL1]: true,
      finalize: true,
      inquiry: true,
    },
    [ScoreType.J2]: {
      [ScoreType.J2]: true,
      [ScoreType.SV2]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL2]: true,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J3]: {
      [ScoreType.J3]: true,
      [ScoreType.SV3]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL3]: true,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J4]: {
      [ScoreType.J4]: true,
      [ScoreType.SV4]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL4]: true,
      finalize: false,
      inquiry: false,
    },
  },
};

export const NCAAW6UEvaluatorConfig = {
  ...NCAAW6EvaluatorConfig,
  utl: true,
  utlPanel: [
    { name: 'UTL1', type: ScoreType.UTL1 },
    { name: 'UTL2', type: ScoreType.UTL2 },
    { name: 'UTL3', type: ScoreType.UTL3 },
    { name: 'UTL4', type: ScoreType.UTL4 },
    { name: 'UTL5', type: ScoreType.UTL5 },
    { name: 'UTL6', type: ScoreType.UTL6 },
  ],
  roles: {
    [ScoreType.J1]: {
      [ScoreType.J1]: true,
      [ScoreType.SV1]: true,
      [ScoreType.ND]: true,
      [ScoreType.UTL1]: true,
      finalize: true,
      inquiry: true,
    },
    [ScoreType.J2]: {
      [ScoreType.J2]: true,
      [ScoreType.SV2]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL2]: true,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J3]: {
      [ScoreType.J3]: true,
      [ScoreType.SV3]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL3]: true,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J4]: {
      [ScoreType.J4]: true,
      [ScoreType.SV4]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL4]: true,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J5]: {
      [ScoreType.J5]: true,
      [ScoreType.SV5]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL5]: true,
      finalize: false,
      inquiry: false,
    },
    [ScoreType.J6]: {
      [ScoreType.J6]: true,
      [ScoreType.SV6]: true,
      [ScoreType.ND]: false,
      [ScoreType.UTL6]: true,
      finalize: false,
      inquiry: false,
    },
  },
};

export const defaultEvaluatorConfig = NCAAMEvaluatorConfig;

export const evaluatorConfigs = {
  NCAAM: NCAAMEvaluatorConfig,
  NCAAM4: NCAAM4EvaluatorConfig,
  FIVE: fiveEvaluatorConfig,
  SINGLE: singleEvaluatorConfig,
  FAN: fanEvaluatorConfig,
  J4: j4EvaluatorConfig,
  NCAAW: NCAAWEvaluatorConfig,
  NCAAW2: NCAAW2EvaluatorConfig,
  NCAAW2SV: NCAAW2SVEvaluatorConfig,
  NCAAW4: NCAAW4EvaluatorConfig,
  NCAAW6: NCAAW6EvaluatorConfig,
  NCAAWU: NCAAWUEvaluatorConfig,
  NCAAW2U: NCAAW2UEvaluatorConfig,
  NCAAW2SVU: NCAAW2SVUEvaluatorConfig,
  NCAAW4U: NCAAW4UEvaluatorConfig,
  NCAAW6U: NCAAW6UEvaluatorConfig,
  FIG5: fig5EvaluatorConfig,
  FIG6: fig6EvaluatorConfig,
  FIG4: fig4EvaluatorConfig,
  OPEN: openEvaluatorConfig,
  DEFAULT: defaultEvaluatorConfig,
};

export const subScoreType = {
  D: 'DIFFICULTY',
  E: 'EXECUTION',
  SV: 'START VALUE',
  ND: 'NEUTRAL DEDUCTION',
  SB: 'STICK BONUS',
  F: 'FAN',
  J: 'JUDGE',
  UTL: 'UP TO LEVEL',
};

export const subScoreTypeAbbv = {
  D: 'D',
  E: 'E',
  ND: 'ND',
  SB: 'SB',
  SV: 'SV',
  F: 'F',
  J: 'J',
  UTL: 'UTL',
};

export const initialEvaluatorState = {
  config: defaultEvaluatorConfig,
  activeInquiryByLineupId: {},
  activeEditByLineupId: {},
};

/**
 * Returns a unified judge panel array from any eval config.
 * - NCAA configs (have jPanel): returns jPanel unchanged
 * - FIG configs (no jPanel, have dPanel + ePanel): returns [...dPanel, ...ePanel]
 * - Fallback: returns empty array
 */
export function getJudgePanel(evalConfig) {
  if (evalConfig?.jPanel?.length > 0) {
    return evalConfig.jPanel;
  }
  const dPanel = evalConfig?.dPanel || [];
  const ePanel = evalConfig?.ePanel || [];
  if (dPanel.length > 0 || ePanel.length > 0) {
    return [...dPanel, ...ePanel];
  }
  return [];
}
